import { Component, OnInit } from '@angular/core';
import { SwPush, SwUpdate } from '@angular/service-worker';
import {
  NotificacionesPushService,
  AuthenticationService,
  HomeService
} from './_services';
import { VERSION } from '../environments/version';
import { Lightbox } from 'ngx-lightbox';
import { Gtag } from 'angular-gtag';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from 'src/environments/environment';
import { Router, NavigationEnd } from '@angular/router';

declare let $: any;
declare let gapi: any;
declare let google: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'dobro';
  isCollapsed = true;
  logueado = false;
  imagenesAuspicio: any;
  imagenesAuspicio2: Array<any> = [];
  versionString = VERSION.version + ' ' + VERSION.raw + ' ' + VERSION.buildDate;
  copyright =
    new Date().getFullYear() > 2018
      ? '2018-' + new Date().getFullYear()
      : '2018';
  miMenu: any;
  nombreUsuario: any;
  googleUserId: string = null;
  whatsappLink: string = '';

  constructor(
    private authenticationService: AuthenticationService,
    private swUpdate: SwUpdate,
    public swPush: SwPush,
    private homeService: HomeService,
    private lightbox: Lightbox,
    gtag: Gtag,
    private gtmService: GoogleTagManagerService,
    private _router: Router
  ) {
    this._router.events.forEach((item) => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url,
        };
        this.gtmService.pushTag(gtmTag);
      }
    });
  }

  ngOnInit() {
    const mensaje = 'Hola, estoy visitando la página de Tropeando y necesito ayuda con algo.';
    const numero = '595976976010';
    this.whatsappLink = `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;
    this.authenticationService.logueado$.subscribe(b => {
      console.log('logueado', b);
      this.logueado = b; // por ser BehaviourSubject ya devuelve automáticamente el primer valor
      if (this.logueado) {
        var currentUser = JSON.parse(
          localStorage.getItem('currentUser')
        );
        this.nombreUsuario = currentUser.nombre.split(' ')[0];
        this.googleUserId = currentUser.googleUser?currentUser.googleUser.id:undefined;
        if (this.nombreUsuario.length > 12) {
          this.nombreUsuario = this.nombreUsuario.substring(0, 11) + '...';
        }
      }
    });
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(evt => {
        console.log(evt);
        if (
          confirm(
            'Nueva versión disponible lanzada en fecha ' +
              evt.available.appData['buildDate'] +
              '. Actualizar?'
          )
        ) {
          window.location.reload();
        }
      });
    }
    this.getImagenesAuspicio();
  }

  isLoggedIn() {
    if (localStorage.getItem('currentUser')) {
      // logged in so return true
      return true;
    }
    return false;
  }

  logout() {
    console.log('Cerrando sesión');
    if (google.accounts.id !== undefined) {
      if(this.googleUserId!== undefined)
      google.accounts.id.revoke(this.googleUserId,
        function () {
          console.log('Google User signed out.');
        });
    }
    return this.authenticationService.logout().subscribe(data => {
      this.logueado = false;
    });
  }

  getImagenesAuspicio() {
    this.homeService.getImagenesPorTipo('auspicio').subscribe(
      data => {
        this.imagenesAuspicio = data;
        this.imagenesAuspicio.forEach(imagen => {
          const album = {
            src: environment.baseUrl + '/..' + imagen.url,
            caption: '',
            thumb: environment.baseUrl + '/..' + imagen.url
          };
          this.imagenesAuspicio2.push(album);
        });
      },
      error => {
        console.log(error);
      }
    );
  }

  openImage(index: number): void {
    this.lightbox.open(this.imagenesAuspicio2, index);
  }

  closeImage(): void {
    // close lightbox programmatically
    this.lightbox.close();
  }
}
